import { useState, type ReactNode } from "react";
import { Disclosure, Separator } from "@heroui/react";
import { Icon, type IconName } from "../Icon";

type SidebarSectionProps = {
  title: string;
  /** Icona a sinistra del titolo; con `openIcon` cambia quando la sezione è aperta (cartelle). */
  icon: IconName;
  openIcon?: IconName;
  defaultExpanded?: boolean;
  /** Controllata dall'esterno (le cartelle dei feed: aperta quella scelta); altrimenti tiene il proprio stato. */
  expanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
  children: ReactNode;
};

/** Sezione comprimibile del pannello laterale ("Fonti attive", "Feed 1", "2026", ...). */
export function SidebarSection({
  title,
  icon,
  openIcon,
  defaultExpanded = false,
  expanded: controlled,
  onExpandedChange,
  children,
}: SidebarSectionProps) {
  const [own, setOwn] = useState(defaultExpanded);
  const expanded = controlled ?? own;
  const change = (next: boolean) => {
    if (controlled === undefined) setOwn(next);
    onExpandedChange?.(next);
  };

  return (
    <Disclosure isExpanded={expanded} onExpandedChange={change} className="flex w-full flex-col">
      <Disclosure.Heading className="flex flex-col gap-[5px]">
        <Disclosure.Trigger className="flex h-6 w-full items-center gap-2.5 rounded-sm text-left">
          <Icon name={expanded && openIcon ? openIcon : icon} />
          <span className="flex-1 text-base leading-6 font-semibold text-brand">{title}</span>
          <Icon name="chevronUp" className={`transition-transform ${expanded ? "" : "-scale-y-100"}`} />
        </Disclosure.Trigger>
        <Separator variant="secondary" className="my-[5.5px]" />
      </Disclosure.Heading>
      <Disclosure.Content>
        <div className="flex flex-col gap-2.5 pt-2.5">{children}</div>
      </Disclosure.Content>
    </Disclosure>
  );
}
